import React from "react";
import SpokePage from "./SpokePage";
import JourneyChapters from "./JourneyChapters";
import { CANDIDATE_JOURNEY } from "../../lib/adelContent";

/* Dedicated page: /candidates/journey — the full 12-step sticky-scene journey. */
export default function CandidateJourneyPage() {
  return (
    <SpokePage
      audience="candidate"
      eyebrow="Your journey with us"
      title={<>Twelve steps. Three phases. <em>Never on your own.</em></>}
      intro="From your first call to long after you land — here is exactly what happens, and where we stay beside you."
      next={{ label: "See where you could work", to: "/candidates/sectors" }}
    >
      <JourneyChapters
        note="Scroll through each phase — the picture stays with you, just like we do."
        phases={CANDIDATE_JOURNEY}
      />
    </SpokePage>
  );
}
